import { useState } from "react";

import { SortState } from "@/types/resources";

const useSort = (defaultSort: SortState) => {
  return useState<SortState>(defaultSort);
};

export default useSort;
